import APIService from '@/services/APIService.js'

export default {
  getGruposRelatorios() {
    return APIService.apiCall().get('/gruposRelatorios/index')
  },
  getGrupoRelatorios(id) {
    return APIService.apiCall().get(`/gruposRelatorios/getGrupoRelatorios/${id}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/gruposRelatorios/salvar/${postData.id}`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/gruposRelatorios/excluir/${id}`);
  },
}